import React, { useState, useEffect } from 'react';
import { useShoppingCart } from '../Context/ShoppingCartContext';

const CardCabañaDisponible = ({ cabaña }) => {
  const [cabañasState, setCabañasState] = useState(cabaña);
  const { addItemToCart } = useShoppingCart();

  const handleAddItem = () => {
    addItemToCart(cabañasState);
  };

  useEffect(() => {
    // sincroniza state si cambia la cabaña prop
    setCabañasState((prev) => {
      const next = { ...cabaña };

      // inicializa personas si viene vacío
      if (next.personas === undefined || next.personas === null) {
        next.personas = 1;
      }

      return next;
    });
  }, [cabaña]);

  return (
    <div className="contenedor grid grid-row-2 bg-gray-100 shadow-lg font-montserrat gap-2 relative">
      <div className="carrusel-info grid grid-cols-1 gap-4">
        <div className="carrusel">
          <img className="w-full h-64 object-cover" src={cabaña.foto} alt={cabaña.tipo} />
        </div>

        <div className="info text-center">
          <div className="info-titulo text-xl font-bold pb-2 pt-4">{cabaña.tipo}</div>

          <div className="info-descripcion pt-2 px-4">{cabaña.descripcion}</div>

          <div className="info-link pb-2">
            <button
              type="button"
              className="underline bg-transparent border-0 p-0 cursor-pointer"
              onClick={() => {
                // Si después tienes link real, aquí navegas.
                // Por ahora no hace nada (evita href inválido).
              }}
            >
              VER DETALLES
            </button>
          </div>
        </div>
      </div>

      <div className="tarifa-boton flex flex-col py-4">
        <div className="tarifa text-center gap-y-2 flex flex-row justify-center gap-x-10 mb-5">
          <div className="font-bold flex flex-col text-center items-center">
            CAPACIDAD
            <p className="p-2 mx-1">{cabaña.capacidad} personas</p>
          </div>

          <div className="font-bold flex flex-col items-center">
            VALOR NOCHE
            <p className="p-2 mx-1 text-center w-min">${cabaña.precio}</p>
          </div>
        </div>

        <div className="boton">
          <button
            className="bg-elqui w-3/4 py-2 text-white h-auto border-none cursor-pointer font-bold"
            onClick={handleAddItem}
          >
            AGREGAR
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardCabañaDisponible;